import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCrop"><Path d="M2.75 5.75H15.25C16.9069 5.75 18.25 7.09315 18.25 8.75V21.25M5.75 2.75V15.25C5.75 16.9069 7.09315 18.25 8.75 18.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCrop;
